import React, {
  createContext,
  useMemo,
  useState,
} from "react";

export const priceConfigurationContext = createContext();
const initialFormDataForAddingPriceConfig = {
  ISO: "",
  PPAType: "",
  PriceZone: "",
  EnergyPrice: "",
  priceConfigName: "",
  siteConfig: [],
};

export const PriceConfigurationContextProvider = (
  props
) => {
  const [authToken, setAuthToken] = React.useState("");
  const [attachedSites, setAttachedSites] = useState([]);
  const [siteSelected, setSiteSelected] = useState(false);
  const [siteSelectedName, setSiteSelectedName] =
    useState("");
  const [groupSelectedName, setGroupSelectedName] =
    useState("");
  const [
    openAddPriceConfigModal,
    setOpenAddPriceConfigModal,
  ] = useState(false);
  const [priceConfigData, setPriceConfigData] =
    React.useState([]);
  const [priceConfigDataCopy, setPriceConfigDataCopy] =
    React.useState([]);
  const [
    siteConfigurationDataToEdit,
    setSiteConfigurationDataToEdit,
  ] = React.useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [priceConfig, setPriceConfig] = useState({
    ...initialFormDataForAddingPriceConfig,
  });
  const [activeStep, setActiveStep] = useState(0);
  const [totalSteps, setTotalSteps] = useState(4);
  const [editConfigModeEnabled, setEditConfigModeEnabled] =
    useState(false);
  const [editModeOn, setEditModeOn] = useState(false);
  const [deletionDialogOpen, setDeletionDialogOpen] =
    useState(false);
  const [
    deleteDialogHeaderMessage,
    setDeleteDialogHeaderMessage,
  ] = useState("");
  const [
    deleteDialogBodyMessage,
    setDeleteDialogBodyMessage,
  ] = useState("");
  const [resetForms, setResetForms] = useState([]);
  const [fluxVisionTuning, setFluxVisionTuning] = useState(true)

  const contextValue = useMemo(() => {
    return {
      siteSelected,
      setSiteSelected,
      siteSelectedName,
      setSiteSelectedName,
      groupSelectedName,
      setGroupSelectedName,
      openAddPriceConfigModal,
      editConfigModeEnabled,
      setEditConfigModeEnabled,
      setOpenAddPriceConfigModal,
      priceConfigData,
      totalSteps,
      searchTerm,
      activeStep,
      setTotalSteps,
      setActiveStep,
      setSearchTerm,
      setPriceConfigData,
      siteConfigurationDataToEdit,
      setSiteConfigurationDataToEdit,
      priceConfig,
      setPriceConfig,
      initialFormDataForAddingPriceConfig,
      deletionDialogOpen,
      setDeletionDialogOpen,
      deleteDialogHeaderMessage,
      setDeleteDialogHeaderMessage,
      deleteDialogBodyMessage,
      setDeleteDialogBodyMessage,
      priceConfigDataCopy,
      setPriceConfigDataCopy,
      authToken,
      setAuthToken,
      attachedSites,
      setAttachedSites,
      resetForms,
      setResetForms,
      fluxVisionTuning,
      setFluxVisionTuning
    };
  }, [
    siteSelected,
    siteSelectedName,
    groupSelectedName,
    openAddPriceConfigModal,
    editConfigModeEnabled,
    setEditConfigModeEnabled,
    priceConfigData,
    activeStep,
    priceConfig,
    siteConfigurationDataToEdit,
    setActiveStep,
    setSiteConfigurationDataToEdit,
    setPriceConfig,
    setPriceConfigData,
    setSiteSelected,
    setSiteSelectedName,
    setGroupSelectedName,
    setOpenAddPriceConfigModal,
    initialFormDataForAddingPriceConfig,
    deletionDialogOpen,
    setDeletionDialogOpen,
    deleteDialogHeaderMessage,
    setDeleteDialogHeaderMessage,
    deleteDialogBodyMessage,
    setDeleteDialogBodyMessage,
    priceConfigDataCopy,
    setPriceConfigDataCopy,
    authToken,
    setAuthToken,
    attachedSites,
    setAttachedSites,
    resetForms,
    setResetForms,
    fluxVisionTuning,
    setFluxVisionTuning
  ]);

  return (
    <priceConfigurationContext.Provider
      value={contextValue}
    >
      {props.children}
    </priceConfigurationContext.Provider>
  );
};
